import { endOfMonth, format, isEqual, isToday, startOfMonth } from 'date-fns';
import { FC } from 'react';
import { merge } from '../../../helpers/Utility';

interface DayProps {
  day: Date;
  viewing: Date;
  selected: Date[];
  isSelected: (date: Date) => boolean;
  inRange: (date: Date, min: Date, max: Date) => boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const Day: FC<DayProps> = ({ day, selected, viewing, isSelected, inRange, onClick, disabled }) => {
  return (
    <div
      style={{ aspectRatio: '1' }}
      className={merge(
        'flex items-center justify-center my-0.5',

        disabled ? 'cursor-not-allowed text-gray-300 dark:text-gray-600' : 'cursor-pointer',

        // Rounds the left side if is the first selected (or only)
        isSelected(day) && isEqual(day, selected[0]) ? 'rounded-l-full' : null,

        // Rounds the right side if is the last selected (or only)
        isSelected(day) && isEqual(day, selected[selected.length - 1]) ? 'rounded-r-full' : null,

        // Is not in the current month being viewed
        !disabled && !inRange(day, startOfMonth(viewing), endOfMonth(viewing)) ? 'text-secondary-std' : null,

        // Subtle highlight of today when today is not selected
        !disabled && isToday(day) && !isSelected(day) ? 'text-blue-700 font-semibold' : null,

        // Boldly highlight & provide hover feedback for currently selected date
        !disabled && isSelected(day) ? 'bg-blue-700 hover:bg-blue-800 text-white font-bold' : null,

        // If not selected (and therefore not using custom colours), provide default hover feedback
        !disabled && !isSelected(day) ? 'hover:bg-gray-100 hover:text-gray-800 hover:rounded-full' : null
      )}
      key={`${day}`}
      onClick={disabled ? undefined : onClick}
    >
      <p>{format(day, 'd')}</p>
    </div>
  );
};
